$(document).ready(function() {
    $('#ask-question').on('submit', function(e) {
        e.preventDefault();
        const formData = $(this).serializeArray();
        const typeQ = formData[0].value;
        const themeQ = formData[1].value;
        const questionQ = formData[2].value;
        const mailQ = formData[3].value;

        ajax(typeQ, themeQ, questionQ, mailQ);
    });
    return false;
});

function ajax(typeQ, themeQ, questionQ, mailQ) {
    $.ajax({
        url: '/api/internal/askQuestion/',
        type: 'post',
        cache: false,
        data: { typeQ, themeQ, questionQ, mailQ },
        dataType: 'json',

        success(data) {
            if (data.answer === true) {
                document.location.href = `/customers/?thanks=${data.id}`;
            } else {
                alert('непредвиденная ошибка');
            }
        },
    });
}
